import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-organization-chart',
  templateUrl: './organization-chart.component.html',
  styleUrls: ['./organization-chart.component.scss']
})
export class OrganizationChartComponent implements OnInit, AfterViewInit {

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.navigationService.scrollCurrentRoute();
  }

}
